var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSendArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 28,
    viewBox: "0 0 30 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.264 14.0043H4.13166M3.84446 15.3493L2.17045 20.4134C1.25361 23.1868 0.795186 24.5736 1.12417 25.4275C1.40985 26.1692 2.02345 26.7313 2.7806 26.9455C3.65248 27.1918 4.96934 26.5916 7.60308 25.3915L24.4878 17.6969C27.0585 16.5253 28.3439 15.9397 28.7411 15.126C29.0863 14.419 29.0863 13.5894 28.7411 12.8825C28.3439 12.0689 27.0585 11.4831 24.4878 10.3116L7.57396 2.60379C4.94815 1.40719 3.63527 0.808888 2.76426 1.05433C2.00782 1.26747 1.39429 1.82822 1.10761 2.56846C0.777493 3.42082 1.23102 4.80457 2.13808 7.57205L3.84771 12.7883C4.00349 13.2636 4.08139 13.5013 4.11213 13.7443C4.13942 13.9601 4.13914 14.1784 4.11131 14.394C4.07994 14.637 4.00145 14.8744 3.84446 15.3493Z",
    stroke: "#E4151B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendArrow);
export default __webpack_public_path__ + "static/media/send-arrow.26f7f8476c738ff9d65faac1a80a283d.svg";
export { ForwardRef as ReactComponent };